<template>
    <section
        :class="'error error_' + status"
    >
        <div class="container">
            <div class="row flex-grow">
                <div class="col-lg-6 mx-auto">
                    <div class="mt-5 mb-5 text-center">
                        <img
                            :src="require('../../../sass/sustainableclothing/img/logo.png').default"
                            :alt="lang('all.logo')"
                            style="max-height:140px;"
                        />
                    </div>

                    <div class="row align-items-center d-flex flex-row">
                        <div class="col-lg-6 text-lg-right pr-lg-4">
                            <h1 class="display-1 mb-0" v-text="status" />
                        </div>
                        <div class="col-lg-6 error-page-divider text-lg-left pl-lg-4">
                            <h2 v-text="title" />
                            <p class="font-weight-light" v-text="description" />
                        </div>
                    </div>
                    <div class="row mt-5" v-if="status !== 503">
                        <div class="col-12 text-center">
                            <a class="font-weight-medium" href="javascript:history.go(-1);">{{ lang('all.terug_naar_de_vorige_pagina') }}</a> |
                            <inertia-link class="font-weight-medium" :href="route('home')">{{ lang('all.terug_naar_de_homepage') }}</inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import Tracking from "../../Shared/Tracking";
import Lang from "../../translations";

export default {

    computed: {
        title() {
            return {
                503: Lang.get('errors.titles.503'),
                500: Lang.get('errors.titles.500'),
                404: Lang.get('errors.titles.404'),
                403: Lang.get('errors.titles.403'),
            }[this.status]
        },
        description() {
            return {
                503: Lang.get('errors.descriptions.503'),
                500: Lang.get('errors.descriptions.500'),
                404: Lang.get('errors.descriptions.404'),
                403: Lang.get('errors.descriptions.403'),
            }[this.status]
        },
    },

    destroyed(){
        document.getElementsByTagName('body')[0].classList.remove('error-page');
        this.$appError.reset();
    },

    extends: Tracking,

    metaInfo() {
        return {
            title: this.title,
        }
    },

    mounted() {
        document.getElementsByTagName('body')[0].classList.add('error-page');
        this.$appError.set(this.status, this.title);
    },

    props: {
        status: Number,
    },
}

</script>
